



































































































































import Vue from "vue";

import NavigationButton from "@/components/NavigationButton.vue";
import DateInput from "../../../../components/DateInput.vue";
import eventBus from "@/services/eventBus";
import store, { InterfaceStore } from "../../services/InterfaceStore";
import GeneralGetPartnersRequestDTO from "../../models/GeneralGetPartnersRequestDTO";

interface Data {
  store: InterfaceStore;
  showSendRequestConfirm: boolean;
  partnerId: string;
  name: string;
  taxaccount: string;
  euTaxaccount: string;
  fromDate: Date | null;
  toDate: Date | null;
}

interface Methods {
  /** A felületi mezőkből a request DTO — az üres mezők null-t / üres listát adnak. */
  buildRequest(): GeneralGetPartnersRequestDTO;
  /** Megerősítő sáv — csak akkor nyílik, ha legalább egy szűrő meg van adva. */
  handleShowConfirm(): void;
  sendRequest(): Promise<void>;
}

export default Vue.extend<Data, Methods, {}, {}>({
  name: "PartnerRequestTool",

  components: {
    NavigationButton,
    DateInput,
  },

  data() {
    return {
      store,
      showSendRequestConfirm: false,
      partnerId: "",
      name: "",
      taxaccount: "",
      euTaxaccount: "",
      fromDate: null,
      toDate: null,
    };
  },

  methods: {
    buildRequest() {
      const partnerId = Number(this.partnerId.trim());
      return {
        partnerIds: this.partnerId.trim() && Number.isInteger(partnerId) && partnerId > 0 ? [partnerId] : [],
        name: this.name.trim() || null,
        taxaccount: this.taxaccount.trim() || null,
        euTaxaccount: this.euTaxaccount.trim() || null,
        syncPeriod: { fromDate: this.fromDate, toDate: this.toDate },
      };
    },

    handleShowConfirm() {
      const r = this.buildRequest();
      const hasFilter = r.partnerIds.length > 0 || !!r.name || !!r.taxaccount || !!r.euTaxaccount
        || !!this.fromDate || !!this.toDate;
      if (!hasFilter) {
        eventBus.$emit("error", "Adjon meg legalább egy szűrési feltételt.");
        return;
      }
      this.showSendRequestConfirm = !this.showSendRequestConfirm;
    },

    /**
     * Az összeállított szűrési feltételek elküldése az aktuális interfészre. Interfész-független: a
     * GeneralGetPartnersRequestDTO-t a backend változatlanul továbbítja az IfaceSync API-nak, az útvonalat
     * az (interfész, típus) páros adja — pl. Verknél a partner/load a köztes táblába tölti a találatokat.
     * Siker után a két lista frissül, a panel bezárul.
     */
    async sendRequest() {
      try {
        await this.store.customDownSyncPartners(this.buildRequest());
        this.showSendRequestConfirm = false;
        this.store.showRequestTool = false;
        eventBus.$emit("refreshSyncList");
        eventBus.$emit("refreshSyncErrorList");
      } catch (e) {
        console.error(e);
      }
    },
  },
});
